module.exports = __webpack_public_path__ + "media/src/images/partners/bundesministerium-c578b560ea9bdc38b6480ae3c278d8dc.jpg";